import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../_core/_services/auth.service';
import { defaultRouteForRole } from '../../../_core/_helpers/role-navigation.helper';

@Component({
  selector: 'app-not-authorized',
  standalone: false,
  templateUrl: './not-authorized.html',
  styleUrl: './not-authorized.css'
})
export class NotAuthorized implements OnInit {
  homeRoute = '/';

  constructor(private auth: AuthService) {}

  ngOnInit(): void {
    this.auth.getCurrentUser().subscribe(user => {
      this.homeRoute = defaultRouteForRole(user?.role);
    });
  }
}
